import React from 'react';
import { motion } from 'framer-motion';
import skillsData from '../data/skills';
import { StickerCode, StickerDevices, StickerCloud, StickerPlug, StickerWrench } from './ui/stickers';
import { stampContainer, stampUp, viewportOnce } from '../lib/motion';

const groupedSkills = {
  programming: skillsData.filter((skill) => skill.category === 'programming'),
  frontend: skillsData.filter((skill) => skill.category === 'frontend'),
  database: skillsData.filter((skill) => skill.category === 'database'),
  api: skillsData.filter((skill) => skill.category === 'api'),
  tools: skillsData.filter((skill) => skill.category === 'tools'),
};

const categoryInfo = {
  programming: { label: 'Core Languages', icon: StickerCode, bg: 'bg-sun' },
  frontend: { label: 'Web & Mobile', icon: StickerDevices, bg: 'bg-bubble' },
  database: { label: 'Database & Cloud', icon: StickerCloud, bg: 'bg-mint' },
  api: { label: 'APIs & Payments', icon: StickerPlug, bg: 'bg-sky' },
  tools: { label: 'Tools & Workflow', icon: StickerWrench, bg: 'bg-sun' },
};

const Skills = () => {
  return (
    <section id="skills" className="py-20 md:py-28 bg-cream dark:bg-card/40 border-t-[3px] border-b-[3px] border-ink dark:border-cream">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={viewportOnce}
          transition={{ duration: 0.4 }}
          className="text-center mb-14"
        >
          <p className="font-display font-bold text-ink/60 dark:text-cream/60 mb-2">What I bring to the table</p>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold text-ink dark:text-cream">
            Skills &amp;{' '}
            <span className="inline-block rotate-1 bg-bubble px-3 brutal-border brutal-shadow-sm">
              Stack
            </span>
          </h2>
        </motion.div>

        <motion.div
          variants={stampContainer}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="rounded-2xl bg-paper dark:bg-noir brutal-border brutal-shadow-lg divide-y-2 divide-ink/15 dark:divide-cream/15"
        >
          {Object.keys(categoryInfo).map((category) => {
            const Icon = categoryInfo[category].icon;
            return (
              <motion.div
                key={category}
                variants={stampUp}
                className="flex flex-col sm:flex-row sm:items-center gap-4 p-6"
              >
                <div className={`flex-shrink-0 flex h-12 w-12 items-center justify-center rounded-xl ${categoryInfo[category].bg} brutal-border-thin`}>
                  <Icon className="w-6 h-6 text-ink" />
                </div>

                <div className="sm:w-48 flex-shrink-0">
                  <h3 className="font-display text-lg font-extrabold text-ink dark:text-cream">
                    {categoryInfo[category].label}
                  </h3>
                </div>

                <div className="flex flex-wrap gap-2">
                  {groupedSkills[category].map((skill) => (
                    <span
                      key={skill.name}
                      className="px-3 py-1 text-xs font-bold rounded-full text-ink dark:text-cream brutal-border-thin"
                    >
                      {skill.name}
                    </span>
                  ))}
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
